export default "__VITE_ASSET__BrnpFgwZ__"